<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>

      <div style="height: 30px;"></div>

      <v-text-field
        v-model="stocktakingMonth"
        :label="$t('sales.stocktaking-month')"
        prepend-icon="event"
        box
        readonly
      ></v-text-field>

      <div style="height: 30px;"></div>

      <v-card>
        <v-container>
          <v-card-title>{{ $t('sales.stocktaking') }}</v-card-title>
          <v-flex xs12 sm12 v-if="existsConfirmItem">
            <v-alert
              :value="true"
              color="warning"
              icon="info"
              outline
              class="font-weight-bold"
              style="text-align: left;"
            >確定済</v-alert>
          </v-flex>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                type="Number"
                min="0"
                v-model="search"
                append-icon="search"
                :label="$t('sales.stocktaking-search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              id="dt"
              :headers="headers"
              :items="stocktakingItems"
              hide-actions
              class="elevation-1"
              style="width: 100%; margin: 15px 0 0;"
              :search="search"
              :customFilter="customFilter"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <tr
                v-bind:class="{
                  'confirmed-items': existsConfirmItem
                }"
              ></tr>

              <template v-slot:items="props">
                <td class="text-xs-center px-2">{{ props.item.janCode }}</td>
                <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                <td
                  class="text-xs-right px-2"
                  v-if="existsConfirmItem"
                >{{ props.item.stockQuantity }}</td>
                <!-- <td class="text-xs-right px-2" v-else>
                  <input
                    type="number"
                    name="itemNum[]"
                    v-model="props.item.stockQuantity"
                    min="0"
                    onfocus="this.value=''"
                    value="0"
                    class="column-input-for-order"
                    :disabled="loading || existsConfirmItem"
                  />
                </td> -->
                <td class="text-xs-right px-2" v-else>
                  <input
                    type="number"
                    name="itemNum[]"
                    v-model="props.item.stockQuantity"
                    min="0"
                    value="0"
                    class="column-input-for-order"
                    :disabled="loading || existsConfirmItem"
                  />
                </td>
              </template>
            </v-data-table>

            <v-flex xs12 sm12>
              <div style="height: 30px;"></div>
            </v-flex>

            <v-flex xs12 sm12>
              <v-textarea
                outline
                v-model="remarks"
                counter="1000"
                :label="$t('sales.order-remarks')"
                clearable
                v-if="!existsConfirmItem"
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm12 v-if="existsConfirmItem">
              <v-textarea
                v-for="item in dispRemarksList"
                :key="item.title"
                outline
                :label="item.userName + 'さんの追伸'"
                readonly
                :value="item.remarks"
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm12>
              <div class="text-xs-center">
                <v-btn
                  align-center
                  block
                  color="success"
                  dark
                  :loading="loading"
                  @click="saveItems()"
                  :disabled="existsConfirmItem"
                >{{ $t('sales.stocktaking-save') }}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <div style="height: 35px;"></div>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn
            block
            color="error"
            dark
            @click="forwardConfirm()"
            :disabled="existsConfirmItem"
          >{{ $t('sales.stocktaking-confirm') }}</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'sales/new-user-menu' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-fab-transition>
        <v-btn
          v-model="fab"
          color="success"
          dark
          fab
          fixed
          bottom
          right
          @click="saveItems()"
          :loading="loading"
          :disabled="existsConfirmItem"
        >
          <v-icon>save</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    // 毎月一日の場合、先月データとして扱う
    if (
      moment().format('YYYYMMDD') ===
      moment()
        .startOf('month')
        .format('YYYYMMDD')
    ) {
      this.stocktakingMonth = moment()
        .subtract(1, 'month')
        .format('YYYY/MM')
    } else {
      this.stocktakingMonth = moment().format('YYYY/MM')
    }

    this.getStocktakingItems()
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    })
  },
  methods: {
    customFilter(items, search) {
      console.log('custom filter')

      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.janCode.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getStocktakingItems() {
      console.log('getStocktakingItems')
      let thisObj = this

      let request = {
        storeCode: this.selectedStore.storeCode,
        stocktakingMonth: this.stocktakingMonth.replace(/\//g, '')
      }

      ServerApiCallService.stocktakingItems(request)
        .then(response => {
          this.existsConfirmItem = response.data.existsConfirmItem

          thisObj.stocktakingItems = response.data.items

          this.remarks = response.data.remarks

          this.dispRemarksList = response.data.remarksList

          var userData = []

          if (this.existsConfirmItem) {
            userData = response.data.confirmItems
          } else {
            userData = response.data.itemsByUserId
          }

          if (userData) {
            // 保存されているユーザーデータがある場合、取り込む処理
            thisObj.stocktakingItems.forEach(function(row) {
              userData.forEach(function(userDataRow) {
                if (row.itemCode == userDataRow.itemCode) {
                  row.quantity = userDataRow.stockQuantity
                  if (userDataRow.stocktakingTempId) {
                    row.stocktakingTempId = userDataRow.stocktakingTempId
                  }
                }
              })
            })
          }

          // 商品の表示順 商品カテゴリ、商品名
          thisObj.stocktakingItems.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })
          thisObj.stocktakingItems.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
          // janCodeの変換
          thisObj.stocktakingItems.forEach(function(row) {
            row.stockQuantity = row.quantity
            row.janCode = row.janCode.substr(9, 4)
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    saveItems() {
      console.log('saveItems')
      this.loading = true

      let request = {
        stocktakingMonth: this.stocktakingMonth.replace(/\//g, ''),
        storeCode: this.selectedStore.storeCode,
        stocktakingTempItems: this.stocktakingItems.filter(
          item => item.stockQuantity > 0 || item.stocktakingTempId
        ),
        remarks: this.remarks
      }

      ServerApiCallService.saveStocktakingItemsByUser(request)
        .then(response => {
          this.getStocktakingItems()
          this.loading = false
        })
        .catch(error => {})
    },

    forwardConfirm() {
      console.log('forwardConfirm')

      this.$router.push({
        name: 'sales/StocktakingConfirm',
        params: {
          stocktakingMonth: this.stocktakingMonth
        }
      })
    }
  },
  data() {
    return {
      dispRemarksList: [],
      remarks: '',
      existsConfirmItem: false,
      loading: false,
      stocktakingMonth: moment().format('YYYY/MM'),
      fab: '',
      search: '',
      stocktakingItems: [],
      headers: [
        {
          text: 'No',
          align: 'left',
          value: 'itemCode',
          width: '5%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '75%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: '物理在庫数',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          width: '20%',
          fixed: true,
          class: 'px-2'
        }
      ]
    }
  }
}
</script>

<style>
.confirmed-items {
  background-color: #adadad;
}
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
.column-input-for-order {
  width: 55px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 2px;
}
</style>
